/* eslint-disable import/order */
// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import { NotificationContainer } from 'react-notifications';
import authHeader from './helpers/authHeader';
import 'react-notifications/lib/notifications.css';

// ----------------------------------------------------------------------

export default function App() {
  console.log(authHeader());
  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <NotificationContainer />
      <Router />
    </ThemeConfig>
  );
}
